import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrgTeamsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const getOrgTeam = (orgTeamId): any => action(types.GET_ORG_TEAM_REQUESTED, orgTeamId);

export const getAllOrgTeams = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORG_TEAMS_REQUESTED, { pagination, compile });

export const selectOrgTeam = (orgTeamId): any => action(types.SELECT_ORG_TEAM_REQUESTED, {
  currentOrgTeamId: orgTeamId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  getOrgTeamPending: (): any => action(types.GET_ORG_TEAM_PENDING, {}),
  getOrgTeamSuccess: (response): any => action(types.GET_ORG_TEAM_SUCCESS, {
    orgTeamsById: response.entities.orgTeams,
    currentOrgTeamId: response.result,
  }),
  getOrgTeamFailed: (error): any => action(types.GET_ORG_TEAM_FAIL, { backendErrors: error }),
  getAllOrgTeamsPending: (pagination): any => action(types.GET_ALL_ORG_TEAMS_PENDING, { pagination }),
  getAllOrgTeamsSuccess: (response, meta): any => action(types.GET_ALL_ORG_TEAMS_SUCCESS, {
    orgTeamsById: response.entities.orgTeams,
    orgTeamIds: response.result,
    meta,
  }),
  getAllOrgTeamsFailed: (error): any => action(types.GET_ALL_ORG_TEAMS_FAIL, { backendErrors: error }),
};

export default {
  getOrgTeam,
  getAllOrgTeams,
  selectOrgTeam,
};
